import { Dashboard } from 'ui/components/agent/patterns/Dashboard/Dashboard';

/**
 * 仲介企業ダッシュボード
 */
export const AgentDashboard: React.FC = () => {
    return <Dashboard />;
};
